/** @type {import('@nuxt/types').Plugin} */
export default (context, inject) => {
    const { app, store } = context;

    /** @return {TIDAL.UserInfo?} */
    const getUserInfo = () => store.state.userInfo;

    /** @type {TIDAL.MenuItem[]} */
    const items = [
        {
            titleKey: 'profile.profileText',
            href: app.localePath('profile'),
            icon: 'ic-profile',
            hasExpandIcon: true,
        },
        {
            titleKey: 'yourData.yourDataText',
            href: app.localePath('your-data'),
            icon: 'ic-mydata',
            hasExpandIcon: true,
            isHidden() {
                /** @type {UserWebApi.UserDataRequestReport | null} */
                const userData = store.state.userData;
                return !userData || userData.status !== 'COMPLETED' || !userData.expiry || userData.expiry < Date.now();
            },
        },
        {
            titleKey: 'subscription.subscriptionText',
            href: app.localePath('subscription'),
            icon: 'ic-subscription',
            hasExpandIcon: true,
        },
        {
            titleKey: 'family.familyText',
            href: app.localePath('family'),
            icon: 'ic-family',
            hasExpandIcon: true,
            isHidden() {
                return getUserInfo()?.subscription.plan !== 'FAMILY';
            },
        },
        {
            titleKey: 'payment.paymentText',
            href: app.localePath('payment'),
            icon: 'ic-payment',
            hasExpandIcon: true,
        },
        {
            titleKey: 'notifications.notificationsText',
            href: app.localePath('notifications'),
            icon: 'ic-notifications',
            hasExpandIcon: true,
            isHidden: () => getUserInfo()?.isUserCountryBlocked || false,
        },
        {
            titleKey: 'offlineDevices.offlineDevicesText',
            href: app.localePath('offline-devices'),
            icon: 'ic-offline-devices',
            hasExpandIcon: true,
            isHidden: () => getUserInfo()?.isUserCountryBlocked || false,
        },
        {
            titleKey: 'webCommon.button.redeem',
            href: app.localePath('redeem'),
            icon: 'ic-redeem',
            hasExpandIcon: true,
            isHidden: () => {
                const userInfo = getUserInfo();
                return !userInfo || userInfo.isChild || userInfo.isPartnerUser || userInfo.isUserCountryBlocked;
            },
        },
        {
            titleKey: 'purchases.purchasesText',
            href: app.localePath('purchases'),
            icon: 'ic-my-purchases',
            hasExpandIcon: true,
        },
        {
            titleKey: 'generic.help',
            href: 'https://support.tidal.com/',
            external: true,
            icon: 'ic-help',
        },
        {
            titleKey: 'webCommon.header.logoutText',
            href: '/logout',
            clickHandler: () => app.$tidalAuth.logout(),
            icon: 'ic-logout',
        },
    ];

    inject('navigation', {
        get currentItem() {
            // Need to retrieve `route` from context directly as object changes after navigation.
            return items.find(item => context.route.path.startsWith(item.href));
        },
        items,
    });
};
